/**
 * CO-VRD Theme — Product page enhancements
 * This file is loaded on product pages only.
 * Heavy lifting (variant selection, ATC, gallery) is handled
 * by the inline <script> in main-product.liquid.
 * This file provides supplementary utilities.
 */
(function () {
  'use strict';

  /* ============================================
     §1  Recently viewed products (localStorage)
     ============================================ */
  var STORAGE_KEY = 'covrd-recently-viewed';
  var MAX_ITEMS   = 10;

  function getRecentlyViewed() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function recordProduct() {
    var meta = document.querySelector('[data-product-id]');
    if (!meta) return;

    var id = meta.dataset.productId;
    var list = getRecentlyViewed().filter(function (item) { return item !== id; });
    list.unshift(id);
    if (list.length > MAX_ITEMS) list = list.slice(0, MAX_ITEMS);

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) { /* quota exceeded — silent */ }
  }

  recordProduct();

  /* ============================================
     §2  Variant deep-linking (URL history)
     ============================================ */
  document.addEventListener('variant:changed', function (e) {
    if (!e.detail || !e.detail.id) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', e.detail.id);
    window.history.replaceState({}, '', url.toString());
  });
})();
